import React, { useContext, useEffect, useState } from 'react';
import { Stepper } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
import CustomizerContext from "../../../../_helper/Customizer";


const StepperComponent = ({setCurrentStep,currentStep, removeAnnList=null}) => {
  const { EligibilityTableShow, ApplicantTableShow, resetGenrateGeneralAvailability } = useContext(CustomizerContext);
    const [steps, setSteps] = useState([
        { label: 'Announcement List', isDisabled: false },
        { label: 'Eligibility List', isDisabled: true },
        { label: 'Applicants List', isDisabled: true },
    ].filter((step) => {
      if(step.label == 'Applicants List' && removeAnnList){
        return false
      }
      return true
    }));

    useEffect(()=>{
      if(removeAnnList){
        setSteps((prev) => {
          return [...prev.filter((item)=>item.label!=='Applicants List')];
        });
      }
    },[removeAnnList])

    useEffect(() => {
      if (EligibilityTableShow) {
        setSteps((prev) => {
          if(removeAnnList){
            return [...prev.filter((item)=>item.label!=='Applicants List')];
          }
          else return [...prev.filter((item)=>item.label!=='Eligibility List'), { label: "Eligibility List", isDisabled: false }];
        });
      } else {
        setSteps((prev) => {
          if(removeAnnList){
            return [...prev.filter((item)=>item.label!=='Applicants List')];
          }
          else return [...prev.filter((item)=>item.label!=='Eligibility List'), { label: "Eligibility List", isDisabled: true }];
          });
      }
      if (ApplicantTableShow) {
        setSteps((prev) => {
          if(removeAnnList){
            return [...prev.filter((item)=>item.label!=='Applicants List')];
          }
          else return [...prev.filter((item)=>item.label!=='Applicants List'), { label: "Applicants List", isDisabled: false }];
        });
      } else {
        
        setSteps((prev) => {
          if(removeAnnList){
            return [...prev.filter((item)=>item.label!=='Applicants List')];
          }
          else return [...prev.filter((item)=>item.label!=='Applicants List'), { label: "Applicants List", isDisabled: true }];
        });
      }
    }, [EligibilityTableShow, ApplicantTableShow, removeAnnList]);

    const handleStepClick = (event) => {
        if (!steps[event.value].isDisabled) {
            setCurrentStep(event.value);
        }
    };

    const toggleStep = (index) => {
        const updatedSteps = steps.map((step, i) => (
            i === index ? { ...step, isDisabled: !step.isDisabled } : step
        ));
        setSteps(updatedSteps);
    };

    const stepStyle = (isDisabled) => ({
        whiteSpace: 'nowrap',
        overflow: 'visible',
        cursor: isDisabled ? 'default' : 'pointer',
    });


    return (
        <div>
            <Stepper
                value={currentStep}
                onChange={handleStepClick}
                items={steps.map((step) => ({
                    label: step.label,
                    isDisabled: step.isDisabled,
                    title: step.label,
                    style: stepStyle(step.isDisabled),
                }))}
                style={{ width: '100%' }}
            />
            {/* <div style={{ marginTop: '20px' }}>
                <Button onClick={() => toggleStep(1)}>
                    Toggle Eligibility List
                </Button>
            </div> */}
        </div>
    );
};

export default StepperComponent;
